module.exports = __webpack_public_path__ + "static/media/agneau.1ae8c9b8.svg";